// extracted by mini-css-extract-plugin
module.exports = {"container":"KeyboardKey_container__1T82j","symbol":"KeyboardKey_symbol__3u9yC"};